<!-- <dynamic-form [formConfig]="dynamicFormProductContract"></dynamic-form> -->
<form class="form" [formGroup]="productForm">
    <div class="form-field">
        <label class="form-label" for="marca">
            {{keyTranslate + '.brand' | translate}}
        </label>
        <input class="form-input" id="marca" type="text" maxlength="50" formControlName="marca">
        <div *ngIf="marca.invalid && (marca.dirty || marca.touched)" class="errorForm"> 
            {{keyTranslate + '.validations.isEmpty' | translate}}

        </div>
    </div>
    
    <div class="form-field">
        <label class="form-label" for="modelo">
            {{keyTranslate + '.model' | translate}}
        </label>
        <input class="form-input" id="modelo" type="text" maxlength="50" formControlName="modelo">
        <div *ngIf="modelo.invalid && (modelo.dirty || modelo.touched)" class="errorForm"> 
            {{keyTranslate + '.validations.isEmpty' | translate}}
        </div>
    </div>

    <div class="form-field">
        <label class="form-label" for="numSerie">
            {{keyTranslate + '.serialNumber' | translate}}
        </label>
        <input class="form-input" id="numSerie" type="text" maxlength="50" formControlName="numSerie">
    </div>
</form>